import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { useAccount, useStore } from '@feathr/extender/state';

import type { IBillableSelectProps } from './BillableSelectBase';
import BillableSelectBase from './BillableSelectBase';

function BillableSelect(props: Readonly<IBillableSelectProps>): JSX.Element {
  const { Billables } = useStore();
  const account = useAccount();

  return (
    <BillableSelectBase
      {...props}
      billables={Billables}
      primaryBillableId={account.get('license').billable}
    />
  );
}

export default observer(BillableSelect);
